import React from "react";

// import Input, {
//   InputType,
//   Password,
// } from "../../components/shared/inputs/input";

import { DatePicker, InputNumber, Select, Tooltip, TreeSelect } from "antd";
import Button from "components/shared/button";
import { SvgLoaderCircle } from "components/svg";


const Material: React.FC = () => {
  // const { control } = useForm<FieldValues>({
  //   defaultValues: {
  //     4: true,
  //     7: true,
  //     6: true,
  //     8: "Option3",
  //     checkox_option_9: true,
  //     checkox_option_7: true,
  //     checkox_option_6: true,
  //     RadioDemo4: "yes",

  //     RadioDemo2: "table_View",
  //     RadioDemo6: "leaf",
  //   },
  // });

  const treeData = [
    {
      value: "parent 11",
      title: "parent 11",
      children: [
        {
          value: "parent 1-0",
          title: "parent 1-0",
          children: [
            {
              value: "leaf1",
              title: "leaf1",
            },
            {
              value: "leaf2",
              title: "leaf2",
            },
          ],
        },
        {
          value: "parent 1-1",
          title: "parent 1-1",
          children: [
            {
              value: "leaf3",
              title: <b data-color="secondary">leaf3</b>,
            },
          ],
        },
      ],
    },
  ];

  // const { RangePicker } = DatePicker;

  return (
    <view data-vertical="" data-adaptive="">
      <view data-space="20" data-container="" data-scroll="" data-size="small">
        <group
          direction="column"
          data-gap="20"
          data-space="20"
          data-align="start"
        //data-border=""
        //data-radius="special"
        >

          <group>
            <cont data-length="300">
              <input
                type="text"
                name="Entrance"
                placeholder=""
                max-length="20"
              />
              <div className="marker primary button" data-shrink="no">
                <text>mm</text>
              </div>
              <decor>
                <label>
                  <text>
                    <line></line>
                    <wrap>
                      <span>Sample Input Component</span>
                      <icon data-space-horizontal="input" data-length="input">
                        info
                      </icon>
                    </wrap>
                  </text>
                  <line></line>
                </label>
                <border></border>
              </decor>
            </cont>
            <separator data-horizontal=""></separator>
            <cont data-length="300">
              <InputNumber
                min={1}
                max={50}
                placeholder={""}
              />
              <div className="marker primary button" data-shrink="no">
                <text>mm</text>
              </div>
              <decor>
                <label>
                  <text>
                    <line></line>
                    <wrap>
                      <span>Number</span>
                      <icon data-space-horizontal="input" data-length="input">
                        redo
                      </icon>
                    </wrap>
                  </text>
                  <line></line>
                </label>
                <border></border>
              </decor>
            </cont>

            <cont data-length="300" s>
              <DatePicker
                bordered={false}
                placeholder={""}

              />
              <decor>
                <label>
                  <text>
                    <line></line>
                    <wrap>
                      <span>Date Picker</span>
                      <icon data-space-horizontal="input" data-length="input">
                        info
                      </icon>
                    </wrap>
                  </text>
                  <line></line>
                </label>
                <border></border>
              </decor>
            </cont>
            <separator data-horizontal=""></separator>
            <cont data-length="300">
              <Select
                placeholder={""}
                options={[
                  {
                    value: "Wolverine",
                    label: <text>Wolverine</text>,
                  },
                ]}
              />

              <decor>
                <label>
                  <text>
                    <line></line>
                    <wrap>
                      <span>Dropdown</span>
                      <icon data-space-horizontal="input" data-length="input">
                        Person
                      </icon>
                    </wrap>
                  </text>
                  <line></line>
                </label>
                <border></border>
              </decor>
            </cont>
            <cont data-length="300">
              <TreeSelect
                treeLine
                suffixIcon={null}
                placeholder={""}
                treeData={treeData}
              />
              <decor>
                <label>
                  <text>
                    <line></line>
                    <wrap>
                      <span>Tree Select</span>
                      <icon data-space-horizontal="input" data-length="input">
                        info
                      </icon>
                    </wrap>
                  </text>
                  <line></line>
                </label>
                <border></border>
              </decor>
            </cont>
          </group>
        </group>
      </view>
      <view data-space="20" data-container="" data-scroll="">
        <group
          direction="column"
          data-gap="20"
          data-space="20"
          data-align="start"
        //data-border=""
        //data-radius="special"
        >
          <group>
            <group data-direction="column">
              <fields data-type="material" data-length="220">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Simple input component</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <input type="text" name="Entrance" placeholder="" />
                  </wrap>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="400">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <icon data-margin="input" data-fill="" data-color="amber">folder</icon>
                                <text>Input component with an <b>icon</b></text>
                                <Tooltip
                                  arrow={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="10"
                                    >
                                      <text data-weight="700">Accent Text Button</text>
                                      <text data-wrap="wrap">
                                        Icon or alternate text will appear, on small screens.
                                      </text>
                                    </group>
                                  }
                                >
                                  <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                                </Tooltip>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                          <Button data-shrink="no" primary text="Temperature" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <input type="text" name="Entrance" placeholder="" />
                  </wrap>
                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button className="marker" data-shrink="no" primary text="mm" />
                        <Button className="marker" data-shrink="no" primary text="Temperature" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="450">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Input component with a <b>placeholder</b></text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button
                            text="Please Wait"
                            textFirst={false}
                            data-shrink="no"
                            effect="material"
                          >
                            <icon >
                              <SvgLoaderCircle />
                            </icon>
                            <separator
                              data-vertical=""
                              data-height="20"
                            ></separator>{" "}
                          </Button>
                        </group>

                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <input type="text" name="Entrance" placeholder="Placeholder" />
                  </wrap>
                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button
                          text="Please Wait"
                          textFirst={false}
                          data-shrink="no"
                        >
                          <icon >
                            <SvgLoaderCircle />
                          </icon>
                          <separator
                            data-vertical=""
                            data-height="20"
                          ></separator>{" "}
                        </Button>
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <group>
                <fields data-type="material" data-fit="1" data-max-length="300" data-min-length="250" data-length="forcefit">
                  <fieldwrap>
                    <decoration>
                      <line data-name="left"></line>
                      <group data-wrap="no" data-length="auto">
                        <wrap data-fit="1">
                          <group data-wrap="no" data-height="fit" data-width="auto">
                            <label data-height="fit">
                              <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                                <line data-name="top"></line>
                                <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                  <text>Input component with a <b>value</b></text>
                                </group>
                              </group>
                              <group data-direction="column" data-height="fit" data-fit="1">
                                <line data-name="top secondary"></line>
                              </group>
                            </label>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                        <wrap>
                          <line data-name="top secondary"></line>
                          <group data-gap="5" data-wrap="no" data-name="action">
                            <Button icon="encrypted" textFirst={true} data-shrink="no" accent_text text="mm" />
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                      </group>
                      <line data-name="right"></line>
                    </decoration>
                    <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                      <input type="text" name="Entrance" placeholder="" value={"Value"} />
                    </wrap>

                    <group data-name="hide" data-width="auto">
                      <wrap>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button className="marker" icon="encrypted" textFirst={true} data-shrink="no" accent_text text="mm" />
                        </group>
                      </wrap>
                    </group>
                  </fieldwrap>
                </fields>

                <fields data-type="material" data-fit="1" data-max-length="250" data-min-length="200" data-length="forcefit">
                  <fieldwrap>
                    <decoration>
                      <line data-name="left"></line>
                      <group data-wrap="no" data-length="auto">
                        <wrap data-fit="1">
                          <group data-wrap="no" data-height="fit" data-width="auto">
                            <label data-height="fit">
                              <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                                <line data-name="top"></line>
                                <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                  <text><b>Desabled</b> input component</text>
                                </group>
                              </group>
                              <group data-direction="column" data-height="fit" data-fit="1">
                                <line data-name="top secondary"></line>
                              </group>
                            </label>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                        <wrap>
                          <line data-name="top secondary"></line>
                          <group data-gap="5" data-wrap="no" data-name="action">
                            <Tooltip
                              arrow={false}
                              title={
                                <group
                                  data-direction="column"
                                  data-gap="10"
                                  data-space="10"
                                >
                                  <text data-weight="700">Accent Text Button</text>
                                  <text data-wrap="wrap">
                                    Icon or alternate text will appear, on small screens.
                                  </text>
                                </group>
                              }
                            >

                              <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                            </Tooltip>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                      </group>
                      <line data-name="right"></line>
                    </decoration>
                    <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                      <input type="text" name="Entrance" placeholder="" value={"Value"} disabled />
                    </wrap>

                    <group data-name="hide" data-width="auto">
                      <wrap>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <icon data-space-horizontal="input" data-length="input">info</icon>
                        </group>
                      </wrap>
                    </group>
                  </fieldwrap>
                </fields>
              </group>

              <group>
                <fields data-type="material" data-length="240">
                  <fieldwrap>
                    <decoration>
                      <line data-name="left"></line>
                      <group data-wrap="no" data-length="auto">
                        <wrap data-fit="1">
                          <group data-wrap="no" data-height="fit" data-width="auto">
                            <label data-height="fit">
                              <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                                <line data-name="top"></line>
                                <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                  <text><b>Validation</b> Input Component</text>
                                </group>
                              </group>
                              <group data-direction="column" data-height="fit" data-fit="1">
                                <line data-name="top secondary"></line>
                              </group>
                            </label>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                        <wrap>
                          <line data-name="top secondary"></line>
                          <group data-gap="5" data-wrap="no" data-name="action">
                            <icon data-space-horizontal="input" data-length="input">info</icon>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                      </group>
                      <line data-name="right"></line>
                    </decoration>
                    <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                      <input type="text" name="Entrance" placeholder="placeholder" className="input-validation-error" />
                    </wrap>
                    <group data-name="hide" data-width="auto">
                      <wrap>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <icon data-space-horizontal="input" data-length="input">info</icon>
                        </group>
                      </wrap>
                    </group>
                  </fieldwrap>
                  <group data-align="center" data-wrap="no" data-name="label">
                    <text data-name="validation_text">Validation Error Text</text>
                  </group>
                </fields>

                <fields data-type="material" data-length="240">
                  <fieldwrap>
                    <decoration>
                      <line data-name="left"></line>
                      <group data-wrap="no" data-length="auto">
                        <wrap data-fit="1">
                          <group data-wrap="no" data-height="fit" data-width="auto">
                            <label data-height="fit">
                              <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                                <line data-name="top"></line>
                                <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                  <text><b>Validation</b> Input Component</text>
                                </group>
                              </group>
                              <group data-direction="column" data-height="fit" data-fit="1">
                                <line data-name="top secondary"></line>
                              </group>
                            </label>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                        <wrap>
                          <line data-name="top secondary"></line>
                          <group data-gap="5" data-wrap="no" data-name="action">
                            <icon data-space-horizontal="input" data-length="input">check</icon>
                          </group>
                          <line data-name="bottom"></line>
                        </wrap>
                      </group>
                      <line data-name="right"></line>
                    </decoration>
                    <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                      <input type="text" name="Entrance" placeholder="placeholder" className="input-validation-success" />
                    </wrap>
                    <group data-name="hide" data-width="auto">
                      <wrap>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <icon data-space-horizontal="input" data-length="input">check</icon>
                        </group>
                      </wrap>
                    </group>
                  </fieldwrap>
                  <group data-align="center" data-wrap="no" data-name="label">
                    <text data-name="validation_text">Validation Success Text</text>
                  </group>
                </fields>
              </group>

              <fields data-type="material" data-length="500">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Simple textarea component</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">

                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <textarea data-resize="none" placeholder="placeholder"></textarea>
                  </wrap>
                </fieldwrap>
              </fields>
            </group>

            <separator data-horizontal=""></separator>

            <group data-direction="column">
              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Number</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <InputNumber
                      //disabled={true}
                      min={1}
                      max={50}
                      placeholder={"Placeholder"}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Date Picker</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <DatePicker
                      //disabled={true}
                      bordered={false}
                      placeholder={"Placeholder"}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Dropdown</text>
                                <Tooltip
                                  arrow={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="10"
                                    >
                                      <text data-weight="700">Accent Text Button</text>
                                      <text data-wrap="wrap">
                                        Icon or alternate text will appear, on small screens.
                                      </text>
                                    </group>
                                  }
                                >

                                  <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                                </Tooltip>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <Select
                      //disabled={true}
                      placeholder={"Placeholder"}
                      data-gap="10"
                      options={[
                        "Spiderman", "IronMan", "Captain America", "Hulk"
                      ].map(hero => ({
                        value: hero,
                        label: <group data-height="30" data-align="center"><text>{hero}</text></group>,
                      }))}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label" data-gap="5">
                                <text>Tree Select</text>
                                <icon data-space-horizontal="input" data-length="input" data-icon-size="10" data-opacity="50">emergency</icon>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button className="marker" data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <TreeSelect
                      disabled={true}
                      treeLine
                      suffixIcon={null}
                      placeholder={"Placeholder"}
                      treeData={treeData}
                      defaultValue={"Value"}
                    />
                  </wrap>
                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button className="marker" data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>
            </group>
          </group>
        </group>
      </view>
      <view data-space="20" data-container="" data-scroll="">
        <group
          direction="column"
          data-gap="20"
          data-space="20"
          data-align="start"
        //data-border=""
        //data-radius="special"
        >
          <group>
            <group data-direction="column">


              <fields data-type="material" data-fit="1" data-max-length="250" data-min-length="200" data-length="forcefit">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text><b>Desabled</b> input component</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Tooltip
                            arrow={false}
                            title={
                              <group
                                data-direction="column"
                                data-gap="10"
                                data-space="10"
                              >
                                <text data-weight="700">Accent Text Button</text>
                                <text data-wrap="wrap">
                                  Icon or alternate text will appear, on small screens.
                                </text>
                              </group>
                            }
                          >

                            <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                          </Tooltip>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <input
                      type="text"
                      name="Entrance"
                      placeholder="placeholder"
                      //value={"Value"} 
                      disabled
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <icon data-space-horizontal="input" data-length="input">info</icon>
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Simple textarea component</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">

                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <textarea
                      disabled
                      placeholder="placeholder"
                    //value={"test"}
                    data-resize="y"

                    ></textarea>
                  </wrap>
                </fieldwrap>
              </fields>
            </group>

            <separator data-horizontal=""></separator>

            <group data-direction="column">
              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Number</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <InputNumber
                      disabled={true}
                      //defaultValue="10"
                      //min={1}
                      // max={50}
                      placeholder={"Placeholder"}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Date Picker</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <DatePicker
                      disabled={true}
                      //defaultValue="2025-03-18"                      
                      bordered={false}
                      placeholder={"Placeholder"}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Dropdown</text>
                                <Tooltip
                                  arrow={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="10"
                                    >
                                      <text data-weight="700">Accent Text Button</text>
                                      <text data-wrap="wrap">
                                        Icon or alternate text will appear, on small screens.
                                      </text>
                                    </group>
                                  }
                                >

                                  <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                                </Tooltip>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <Select
                      disabled={true}
                      //defaultValue={"Value"}
                      placeholder={"Placeholder"}
                      options={[
                        {
                          value: "Wolverine",
                          label: <text>Wolverine</text>,
                        },
                      ]}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>


              <fields data-type="material" data-length="300">
                <fieldwrap >
                  <decoration >
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label" data-gap="5">
                                <text>Tree Select</text>
                                <icon data-space-horizontal="input" data-length="input" data-icon-size="10" data-opacity="50">emergency</icon>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button className="marker" data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <TreeSelect
                      disabled={true}
                      //defaultValue={"Value"}
                      treeLine
                      suffixIcon={null}
                      placeholder={"Placeholder"}
                      treeData={treeData}
                    />
                  </wrap>
                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button className="marker" data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>
            </group>
          </group>
        </group>

      </view>
      <view data-space="20" data-container="" data-scroll="">
        <group
          direction="column"
          data-gap="20"
          data-space="20"
          data-align="start"
        //data-border=""
        //data-radius="special"
        >
          <group>
            <group data-direction="column">


              <fields data-type="material" data-fit="1" data-max-length="250" data-min-length="200" data-length="forcefit">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text><b>Desabled</b> input component</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Tooltip
                            arrow={false}
                            title={
                              <group
                                data-direction="column"
                                data-gap="10"
                                data-space="10"
                              >
                                <text data-weight="700">Accent Text Button</text>
                                <text data-wrap="wrap">
                                  Icon or alternate text will appear, on small screens.
                                </text>
                              </group>
                            }
                          >

                            <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                          </Tooltip>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <input type="text" name="Entrance" placeholder="placeholder" value={"Value"} disabled />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <icon data-space-horizontal="input" data-length="input">info</icon>
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Simple textarea component</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">

                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <textarea
                      disabled
                      placeholder="placeholder"
                      value={"Value"}
                      data-resize="none"

                    ></textarea>
                  </wrap>
                </fieldwrap>
              </fields>
            </group>

            <separator data-horizontal=""></separator>

            <group data-direction="column">
              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Number</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <InputNumber
                      disabled={true}
                      defaultValue="10"
                      //min={1}
                      // max={50}
                      placeholder={"Placeholder"}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Date Picker</text>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <DatePicker
                      disabled={true}
                      //defaultValue="2025-03-18"                      
                      bordered={false}
                      placeholder={"Placeholder"}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label">
                                <text>Dropdown</text>
                                <Tooltip
                                  arrow={false}
                                  title={
                                    <group
                                      data-direction="column"
                                      data-gap="10"
                                      data-space="10"
                                    >
                                      <text data-weight="700">Accent Text Button</text>
                                      <text data-wrap="wrap">
                                        Icon or alternate text will appear, on small screens.
                                      </text>
                                    </group>
                                  }
                                >

                                  <icon data-color="main" data-info="" data-cursor="pointer" data-space-horizontal="input" data-length="input">info</icon>
                                </Tooltip>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <Select
                      disabled={true}
                      defaultValue={"Value"}
                      placeholder={"Placeholder"}
                      options={[
                        {
                          value: "Wolverine",
                          label: <text>Wolverine</text>,
                        },
                      ]}
                    />
                  </wrap>

                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>

              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label" data-gap="5">
                                <text>Tree Select</text>
                                <icon data-space-horizontal="input" data-length="input" data-icon-size="10" data-opacity="50">emergency</icon>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button className="marker" data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <TreeSelect
                      disabled={true}
                      defaultValue={"Value"}
                      treeLine
                      suffixIcon={null}
                      placeholder={"Placeholder"}
                      treeData={treeData}
                    />
                  </wrap>
                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button className="marker" data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>
              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label" data-gap="5">
                                <text>Tree Select</text>
                                <icon data-space-horizontal="input" data-length="input" data-icon-size="10" data-opacity="50">emergency</icon>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>
                        <group data-gap="5" data-wrap="no" data-name="action">
                          <Button className="marker" data-shrink="no" primary text="mm" />
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <TreeSelect
                      //disabled={true}
                      //defaultValue={"Value"}
                      treeLine
                      suffixIcon={null}
                      placeholder={"test"}
                      treeData={treeData}
                    />
                  </wrap>
                  <group data-name="hide" data-width="auto">
                    <wrap>
                      <group data-gap="5" data-wrap="no" data-name="action">
                        <Button className="marker" data-shrink="no" primary text="mm" />
                      </group>
                    </wrap>
                  </group>
                </fieldwrap>
              </fields>
              <fields data-type="material" data-length="300">
                <fieldwrap>
                  <decoration>
                    <line data-name="left"></line>
                    <group data-wrap="no" data-length="auto">
                      <wrap data-fit="1">
                        <group data-wrap="no" data-height="fit" data-width="auto">
                          <label data-height="fit">
                            <group data-height="fit" data-align="center" data-width="auto" data-name="label_wrap">
                              <line data-name="top"></line>
                              <group data-height="fit" data-align="center" data-width="auto" data-wrap="no" data-name="label" data-gap="5">
                                <text>Multiselect</text>
                                <icon data-space-horizontal="input" data-length="input" data-icon-size="10" data-opacity="50">emergency</icon>
                              </group>
                            </group>
                            <group data-direction="column" data-height="fit" data-fit="1">
                              <line data-name="top secondary"></line>
                            </group>
                          </label>
                        </group>
                        <line data-name="bottom"></line>
                      </wrap>
                      <wrap>
                        <line data-name="top secondary"></line>

                        <line data-name="bottom"></line>
                      </wrap>
                    </group>
                    <line data-name="right"></line>
                  </decoration>
                  <wrap data-type="group" data-gap="5" data-wrap="" data-height="fit" data-length="autofit" data-contain="">
                    <Select
                      mode="tags"
                      //size={size}
                      placeholder="Please select"
                      defaultValue={['c14', 'c15']}
                      //onChange={handleChange}
                      style={{ width: '100%' }}
                      options={[
                        {
                          value: "Wolverine",
                          label: <text>c11</text>,
                        },
                        {
                          value: "Wolverine",
                          label: <text>c12</text>,
                        },

                      ]}
                    />

                  </wrap>
                  <group data-name="hide" data-width="auto">

                  </group>
                </fieldwrap>
              </fields>
            </group>
          </group>
        </group>

      </view>
    </view>
  );
};
export default Material;
